module.exports = __webpack_public_path__ + "static/media/Ombudet_logo(mørk) 1.c2943cf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Kontakt/static/Ombudet_logo(mørk) 1.png
// module id = 179
// module chunks = 0